<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Crusaders and Revolutionaries of the Thirteenth Century: De Montfort</h1>
<p class="author">Darren Baker</p>
<div class="img_container1">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?058e261c